import { Box, Grid, Typography } from '@mui/material';
import { useStyles } from './Style2';
import _ from 'lodash';
import { PageContainer, PriceLabel } from 'components';
import { numberWithCommas } from 'utility';
import { useState } from 'react';
import InitFilteringReportSummary from '../constants/InitFilteringReportSummary';
import { toFilterVOS } from 'components/FilterPod';
import { FilterPod, ExportButton } from 'components';
import { useExportFile } from 'hooks';
import Serivces from '../../services/Serivces';
import { NewLoading } from 'components';
import { filterVOStoQueryStrWithId } from 'components/FilterPod/services/Services';
import generateData from './generateData';
import FilterButton from 'components/FilterPod/FilterButton';
import { useCurrencyUnit } from 'hooks';

export default function FunderSeparateReportSummary({ id }) {
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState(InitFilteringReportSummary);
  const [filterParams, setFilterParams] = useState(null);
  const classes = useStyles();
  const [data, setData] = useState(null);
  const currencyText = useCurrencyUnit(false);
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilterDialog = () => setOpenFilterDialog(false);

  const { downloadFile, isExporting } = useExportFile({
    url: `/report/funder/${id}/export`,
    filename: 'assigned-delegations-report',
  });

  const getData = () => {
    setLoading(true);
    setData(null);
    let filter = toFilterVOS([...filters]);
    let queries = filterVOStoQueryStrWithId(filter);

    let params = {
      ...queries,
    };
    const data = {
      filterVOS: [],
      parentParams: [],
      orderByElementVOS: [],
    };
    setFilterParams({ data, params });
    Serivces.getSummaryReportFunder(id, data, params)
      .then((res) => {
        let list = [];
        if (res.result.rows) {
          list = generateData(res.result.rows);
        }
        setData(list[0]);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const onFiltersChange = (newFilters) => {
    setFilters(newFilters);
    getData();
  };
  const onChangeTemp = (f) => {
    setFilters(f);
  };
  const onExport = (type, index) => {
    const types = ['xls', 'csv'];
    downloadFile(types[index], filterParams?.data, filterParams?.params);
  };

  const hint =
    'محدوده تاریخ حداکثر 3 ماه گذشته می باشد.جهت نمایش گزارش، پس از انتخاب بازه زمانی مورد نظر بر روی دکمه جستجو کلیک نمایید.';

  return (
    <PageContainer title="گزارش تفکیکی" className={classes.root} description={hint}>
      <Grid item xs={12}>
        <Box display="flex" justifyContent="end" alignItems="flex-end" style={{ marginBottom: 16 }}>
          <FilterButton setOpenFilterDialog={setOpenFilterDialog} filters={filters} />
          <ExportButton loading={isExporting} types={['xls', 'csv']} onExport={onExport} />
        </Box>
        <Box>
          <FilterPod
            filters={filters}
            onChange={onFiltersChange}
            onChangeTemp={onChangeTemp}
            openFilterDialog={openFilterDialog}
            setOpenFilterDialog={setOpenFilterDialog}
            handleCloseFilterDialog={handleCloseFilterDialog}
          />
        </Box>
      </Grid>
      <Grid container direction="row" alignItems="center" item>
        <Grid item xs={12}>
          {loading ? (
            <Grid container xs={12} md={12} style={{ position: 'relative', minHeight: '200px' }}>
              <NewLoading />
            </Grid>
          ) : (
            <Grid container xs={12} md={12} className={classes.info}>
              <Grid item xs={12} md={6} lg={3} className={classes.detail}>
                <Typography className={classes.detailTitle}>تعداد کل تراکنش</Typography>
                <Typography className={classes.detailValue}>
                  {numberWithCommas(data?.totalTransaction) || '-'}
                </Typography>
              </Grid>
              <Grid item xs={12} md={6} lg={3} className={classes.detail}>
                <Typography className={classes.detailTitle}>مجموع واریز</Typography>
                <Typography className={classes.detailValue}>
                  <PriceLabel amount={data?.sumDeposit} />
                </Typography>
              </Grid>
              <Grid item xs={12} md={6} lg={3} className={classes.detail}>
                <Typography className={classes.detailTitle}>مجموع برداشت</Typography>
                <Typography className={classes.detailValue}>
                  <PriceLabel amount={data?.sumWithdrawal} />
                </Typography>
              </Grid>
              <Grid item xs={12} md={6} lg={3} className={classes.detail}>
                <Typography className={classes.detailTitle}>مانده {currencyText}ی </Typography>
                <Typography className={classes.detailValue}>
                  <PriceLabel amount={data?.remaining} />
                </Typography>
              </Grid>
              <Grid item xs={12} md={6} lg={3} className={classes.detail}>
                <Typography className={classes.detailTitle}>مانده اعتبار مصرف نشده </Typography>
                <Typography className={classes.detailValue}>
                  <PriceLabel amount={data?.creditBalance} />
                </Typography>
              </Grid>
              <Grid item xs={12} md={6} lg={3} className={classes.detail}>
                <Typography className={classes.detailTitle}>
                  مجموع قابل مصرف (نقد و اعتبار){' '}
                </Typography>
                <Typography className={classes.detailValue}>
                  <PriceLabel amount={data?.totalBalanceDeposite} />
                </Typography>
              </Grid>

              <Grid item xs={12} md={6} lg={3} className={classes.detail}>
                <Typography className={classes.detailTitle}>مبلغ کل اعتبار تخصیص شده </Typography>
                <Typography className={classes.detailValue}>
                  <PriceLabel amount={data?.totalBalance} />
                </Typography>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
    </PageContainer>
  );
}
